export default __webpack_public_path__ + "static/stickerSale2022-f70dcd18038c3695831c216707251c19.png";